export const Ai = {
  state: {
    analyses: [],
  },

  getters: {
    getAnalysisForCase: (state) => (parentCase) => {
      return state.analyses.filter(({ relatedCase }) => relatedCase.id === parentCase.id);
    },

    getAnalysisByEngine: (state, getters) => (parentCase, engineName) => {
      return getters
        .getAnalysisForCase(parentCase)
        .filter(({ engine }) => engine === engineName)
        .sort((a, b) => a.id < b.id);
    },

    getLastAnalysisForEngine: (state, getters) => (parentCase, engineName) => {
      return getters.getAnalysisByEngine(parentCase, engineName).pop();
    },
  },

  mutations: {
    setAnalyses: (state, analyses) => {
      state.analyses = analyses;
    },

    addAnalysis: (state, analysis) => {
      state.analyses.push(analysis);
    },
  },
};
